import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';

import { RootState } from '../store';
import { orgPhone } from '../selectors/organization';
import { ReactComponent as ExclamationIcon } from '../images/exclamation-icon.svg';

import styles from './AuthErrorModal.module.css';

function AuthErrorModal({ phoneNumber }: { phoneNumber: string }) {
  const errorHeaderRef = useRef<HTMLDivElement>(null);
  const intl = useIntl();

  useEffect(() => {
    if (errorHeaderRef.current) {
      errorHeaderRef.current.focus();
    }
  }, []);

  return (
    <div className={styles.modalBackground}>
      <div
        className={styles.modal}
        ref={errorHeaderRef}
        tabIndex={0}
        aria-label={intl.formatMessage({ id: 'authErrorModal.errorHeader' })}
      >
        <div className={styles.errorIconBackground}>
          <ExclamationIcon className={styles.exclamationIcon} />
        </div>
        <div className={styles.errorHeader}>
          <FormattedMessage id={'authErrorModal.errorHeader'} />
        </div>
        {phoneNumber && (
          <div
            className={styles.supportBody}
            tabIndex={0}
            aria-label={intl.formatMessage(
              { id: 'authErrorModal.supportBodyWithPhno' },
              { phoneNumber }
            )}
          >
            <FormattedMessage id={'authErrorModal.supportBody'} />
            <a className={styles.supportNumber} href={`tel:${phoneNumber}`}>
              {phoneNumber}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

const mapState = (state: RootState) => ({
  phoneNumber: orgPhone(state),
});

export default connect(mapState)(AuthErrorModal);
